import { FC } from 'react';

const styles: Record<string, React.CSSProperties> = {
  materialIcon: {
    fontSize: '16px',
    bottom: -2,
    position: 'relative',
    marginLeft: '4px',
  },
};

export const OpenInNewIcon: FC<React.PropsWithChildren<unknown>> = () => {
  return (
    <span className="material-icons-outlined" style={styles.materialIcon}>
      open_in_new
    </span>
  );
};
